import { useDeleteOrder } from '#api-bridge/orderApi.ts';

export const useCancelOrder = () => {
    const [deleteOrder, { isLoading }] = useDeleteOrder();
    const cancelOrder = async (orderId: string) => {
        return deleteOrder(orderId)
            .unwrap()
            .then(() => {
                return true;
            })
            .catch(e => {
                console.error(`Failed to cancel order ${orderId}`, e);
                return false;
            });
    };
    return { cancelOrder, isLoading };
};
